export default {
  state: {
    email: '',
    phone: ''
  },
  mutations: {
    setUserContact (state, { email, phone }) {
      state.email = email
      state.phone = phone
    }
  },
  actions: {
    setUserContact ({ commit }, contact) {
      commit('setUserContact', contact)
    }
  },
  getters: {
    getUserContact (state) {
      return { email: state.email, phone: state.phone }
    }
  }
}
